import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import { withConfig } from 'modules/shell/hoc/withConfig';
import { withLogger } from 'modules/shell/hoc/withLogger';
import { addNotification, resetActiveUserADGroup } from '../../actions';
import Login from './Login';
import styles from './Login.styles';

const mapStateToProps = ({ userGroups: { activeADGroup } }) => ({
  activeADGroup,
});

const mapDispatchToProps = {
  addNotification,
  resetActiveUserADGroup,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withConfig(),
  withStyles(styles),
  withLogger(),
)(withRouter(Login));
